export class PageSettings {
  channel: DistributionChannel;
  page: number;
  size: number;
  sort: string;
  order: string;
}

